export default {
  title: 'Wichtige Hinweise',
  buttons: {
    add_note: 'Hinweis hinzufügen',
  },
};
